module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar-event-files/calendar-event-files.component.css
// module id = ./src/app/calendar-event-files/calendar-event-files.component.css
// module chunks = main